import { createSelector } from 'reselect';

export const alertsObjSelector = state => state.alerts || {};

export const alertsSelector = createSelector(alertsObjSelector, alertsObj =>
  alertsObj.alerts ? Object.values(alertsObj.alerts) : [],
);
